import { render } from "./logging.banzaicloud.io.flow.vue?vue&type=template&id=8da85a8e"
import script from "./logging.banzaicloud.io.flow.vue?vue&type=script&lang=js"
export * from "./logging.banzaicloud.io.flow.vue?vue&type=script&lang=js"

import exportComponent from "../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__